@use 'sass:map';
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

.user-menu {
  position: relative;
  width: fit-content;

  > .notification-dot {
    z-index: 1;
  }

  > button {
    display: flex;
    align-items: center;
    column-gap: 12px;
    border-radius: 50px;
    color: inherit;

    > .picture {
      flex: 0 0 auto;
      height: 46px;
      width: 46px;
      border-radius: 50%;
    }

    > .info {
      flex: 0 1 auto;
      display: none;
      align-items: baseline;
      flex-direction: column;

      > .displayname,
      > .function {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      > .displayname {
        font-size: var(--#{$prefix}font-size-md);
        font-weight: bold;
      }

      > .function {
        font-size: var(--#{$prefix}font-size-xs);
      }
    }

    > svg {
      flex: 0 0 auto;
      display: none;
      opacity: 0.3;
      margin-right: 12px;
      transition: rotate 0.2s ease-in-out;
    }

    &:hover,
    &:focus-visible {
      > svg {
        opacity: 1;
      }
    }

    &:focus-visible {
      outline: 4px solid var(--#{$prefix}primary);
    }
  }

  > ul {
    @include unstyled-list;
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 270px;
    max-width: calc(100vw - 32px);
    background-color: var(--#{$prefix}body-bg);
    border-radius: 8px;
    box-shadow: var(--#{$prefix}shadow-strong) HEXToRGBA($black, 0.1);
    overflow: hidden;
    z-index: 1000;

    > li {
      > a,
      > button {
        @include unstyled-link;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 16px;
        padding: 14px 12px;
        text-wrap: nowrap;
        font-size: var(--#{$prefix}font-size-sm);
        width: 100%;

        > svg {
          min-width: var(--#{$prefix}body-font-size);
          opacity: 0.3;
        }

        &#notification {
          position: relative;

          > .badge {
            position: absolute;
            right: 12px;
          }
        }

        &#logout {
          color: var(--#{$prefix}system-red);
        }

        &:hover,
        &:focus-visible {
          font-weight: 500;
          background-color: var(--#{$prefix}hover);
          outline: none;

          > svg {
            opacity: 1;
          }
        }
      }

      &:has(> button#search) {
        display: none;
      }
    }
  }

  @media (width >= map.get($custom-breakpoints, user-info)) {
    > ul > li:has(> button#info-etab) {
      display: none;
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > .notification-dot {
      display: none;
    }

    > button {
      > .info {
        display: flex;
      }

      > svg {
        display: unset;
      }
    }

    > ul > li {
      &:has(> button#notification, > button#info-etab) {
        display: none;
      }

      &:not(:last-child) {
        border-bottom: 1px solid HEXToRGBA($black, 0.1);
      }
    }
  }
}
